import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
export var Breadcrumbs = function Breadcrumbs() {
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Image, null));
};
var Image = function Image() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 20,
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 6,
    y: 7,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 6,
    x: 113,
    y: 7,
    fill: "#454F59",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#738496",
    d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
  }));
};